<template><svg xmlns="http://www.w3.org/2000/svg" width="61" height="44" viewBox="0 0 35 45">
  <g style="stroke: currentColor; stroke-width: 2.38; fill: none; fill-rule: evenodd; stroke-linecap: round; stroke-linejoin: round" transform="translate(1 1)">
    <path d="m.19 4.57v37.72h32.3v-42.1h-28.01z" />
    <path d="m16.34 29.7v-20.25" />
    <path d="m21.44 24.21-5.1 5.49-5.1-5.49" />
    <path d="m8.6 34.45h15.48" />
    <path d="m7.91 3.46v4.03h-4.03" />
  </g>
</svg>
</template>